import { Component, OnInit, ViewChild } from '@angular/core';

import { BlogService } from '../../services/blog.service';
import { Blog } from '../../models/blog';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { SETTING } from '../constants/constants';
import { CategoryService } from 'src/app/services/categories.service';
import { Category } from 'src/app/models/category';
import { Router, ActivatedRoute } from '@angular/router';
import {MessageService} from 'primeng/api';
import { Clients } from 'src/app/models/clients';
import { ComuniService } from 'src/app/services/comuni.service';
import { Appointments } from 'src/app/models/appointments';
import { AppointmentsService } from 'src/app/services/appointments.service';

import { CardModule } from "primeng/card";
import { RouterLink } from "@angular/router";
import { RouterLinkActive } from "@angular/router";

@Component({
    selector: 'app-settings',
    templateUrl: './settings.component.html',
    imports: [CardModule, RouterLink, RouterLinkActive]
})
export class SettingsComponent implements OnInit {

  calendarOptions: any;
  events: any;
  appointments: Appointments;
  error: string;
  blogForm: UntypedFormGroup;
  typeList: any;
  settingsPages: any;
  cities: Blog[];
  format1: string = "";
  format2: string = "";
  selectedCity: Blog;
  uploadError: string;
  selectedCategories: Category;
  selectedDate: Date;
  date: Date;
  categories: any = [];
  category: Category;
  productDialog:boolean = false;
  appointmentsDialog: boolean = false;
  clients: any = [];
  client: Clients;
  comuni: any = [];
  clientSettings: any = [];
  settings: any = [];
  itemsProduct: any = [];
  itemsCompany: any = [];

trackByFn(index, item) {
  return item.id;
}


  constructor(private blogService: BlogService,     
    private appointmentsService: AppointmentsService,
    private fb: UntypedFormBuilder,
    private comuniService: ComuniService,
    private categoryService: CategoryService, 
    private router: Router,
    private messageService: MessageService,
    private route: ActivatedRoute
    ) {
      this.itemsProduct = [];
      this.itemsCompany = [];

   }

  ngOnInit() {
    this.settings = SETTING;
} 

  
}
